import { useAuthorization } from 'src/hooks/use-authorization';

export const useShowInlineFormModal = () => {
  const { getFeatureFlag } = useAuthorization();

  return getFeatureFlag('ux-redesign-v2.5') && getFeatureFlag('inline-forms-redesign');
};
